import React from 'react';

import {CheckboxSkeleton, FormSectionSkeleton} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';


export const NextLoginActionsSkeleton = () => (
    <FormSectionSkeleton labelWidth={264}>
        <Group direction="v">
            <CheckboxSkeleton labelWidth={168}/>
            <CheckboxSkeleton labelWidth={168}/>
        </Group>
    </FormSectionSkeleton>
);
